var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableTennis({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    style: {
      fill: "currentcolor",
      color: "currentcolor",
      width: 18,
      height: "auto"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.079 14.74l12.398 12.398c1.767-0.38 3.441-1.286 4.859-2.703 3.934-3.934 3.876-10.382-0.144-14.402s-10.468-4.078-14.402-0.144c-1.42 1.42-2.328 3.090-2.71 4.852zM19.051 27.328l-11.165-11.165c-0.102 1.814 0.336 3.678 1.328 5.427 0.388 0.683 0.177 1.252-0.297 1.854-0.204 0.259-0.391 0.453-0.921 0.978-0.541 0.535-0.8 0.803-1.082 1.136-1.103 1.301-1.242 2.129-0.31 3.062s1.758 0.793 3.059-0.311c0.33-0.281 0.597-0.538 1.128-1.076 0.527-0.533 0.722-0.721 0.983-0.926 0.603-0.473 1.173-0.684 1.856-0.299 1.747 0.985 3.609 1.42 5.421 1.321zM4.571 8.571c-2.209 0-4-1.791-4-4s1.791-4 4-4c2.209 0 4 1.791 4 4s-1.791 4-4 4zM4.571 7.429c1.578 0 2.857-1.279 2.857-2.857s-1.279-2.857-2.857-2.857c-1.578 0-2.857 1.279-2.857 2.857s1.279 2.857 2.857 2.857zM12.416 28.839c-0.577 0.584-0.877 0.874-1.274 1.211-2.099 1.782-4.204 2.136-6.155 0.185s-1.597-4.057 0.183-6.156c0.339-0.4 0.631-0.702 1.219-1.283 0.283-0.28 0.452-0.45 0.569-0.576-2.42-4.721-1.61-10.124 2.215-13.949 4.833-4.833 12.728-4.762 17.634 0.144s4.977 12.801 0.144 17.634c-3.815 3.815-9.227 4.622-13.951 2.212-0.127 0.117-0.299 0.288-0.584 0.576z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableTennis);
export default __webpack_public_path__ + "static/media/tableTennis.bbc8c42472f8863343e41cc50ed3dd5a.svg";
export { ForwardRef as ReactComponent };